import * as React from 'react';
import {FunctionComponent} from 'react';
import {IndoorWorkoutExport} from '../../../Components/Workout/Indoor/IndoorWorkoutExport';
import {IndoorFullWorkout} from '../../../../Models/FullWorkout';
import {Share} from '../../../Components/Workout/Generic/Share';
import {TrainingPlanHistory} from '../../../Components/Workout/Indoor/TrainingPlanHistory';
import {UploadToStrava} from '../../../Components/Workout/Generic/UploadtoStrava';
import {Feedback} from '../../../Components/Feedback';
import {Csrf} from '../../../Components/Form/Csrf';
import {Me} from '../../../../Models/Me';
import {FeatureFlags} from '../../../../FeatureFlags';
import {SaveSnippet} from './SaveSnippet';
import {AdvancedAdvert, AdvancedAdvertType} from '../../../Components/AdvancedAdvert';
import {TransferWorkout} from '../../../Components/Workout/Generic/TransferWorkout';
import {Stroke} from '../../../../Models/Stroke';

interface OwnProps {
    indoorFullWorkout: IndoorFullWorkout;
    me: Me;
    strokes?: Stroke[];
}

export const Sidebar: FunctionComponent<OwnProps> = ({indoorFullWorkout, me, strokes}) => {
    return (
        <>
            <IndoorWorkoutExport className="mb-3 mt-lg-0 mt-3" indoorPartialWorkout={indoorFullWorkout} />
            {!FeatureFlags.snippets && FeatureFlags.isAdvancedSubscriptionsEnabled && (
                <AdvancedAdvert className="mb-3" type={AdvancedAdvertType.WORKOUT_DETAIL} />
            )}
            {(FeatureFlags.snippets && strokes) && <SaveSnippet className="mb-3" fullWorkout={indoorFullWorkout} strokes={strokes}/>}
            <TrainingPlanHistory className="mb-3" fullWorkout={indoorFullWorkout} />
            <Share className="mb-3" partialWorkout={indoorFullWorkout} />
            <UploadToStrava className="mb-3" me={me} fullWorkout={indoorFullWorkout} />
            {FeatureFlags.crews && indoorFullWorkout.user_id === me.id && (
                <TransferWorkout className="mb-3" fullWorkout={indoorFullWorkout} />
            )}
            <Feedback className="mb-3" />
            <div className="row mb-3">
                <div className="col-12 text-center">
                    <form
                        action={`/workout/${indoorFullWorkout.id}/delete`}
                        method="post"
                        onSubmit={(e) => {
                            if (!confirm('Are you sure you want to delete this workout?')) {
                                e.preventDefault();
                                return false;
                            }
                        }}
                    >
                        <Csrf />
                        <button className="btn">
                            <i className="bi-trash me-2" />
                            Delete workout
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
};
